export default __webpack_public_path__ + "static/media/environment-o.f50ac0c5.svg";